import React, { memo, useCallback, forwardRef, useImperativeHandle } from 'react'
import fetchAPI from '../../../../../lib/utils/fetch-api'
import { ExportExcelButton, format2Print } from 'src/react-app/components/v2/export-excel-button'

export interface MeasurementPrintButtonProps {
  path: string
  columns: any[]
  stages: any[]
}

export interface MeasurementPrintButtonRef {
  onPrintClick: () => Promise<void>
}

export const MeasurementPrintButton = memo(
  forwardRef<MeasurementPrintButtonRef, MeasurementPrintButtonProps>(({ path, columns, stages }, ref) => {
    const handlePrintClick = useCallback(async () => {
      try {
        const response = await fetchAPI(path)
        const data = response.data
        console.log('data', data)
        if (!data) {
          return
        }

        const viewColumnNames = columns.map((column) => column.dataIndex)
        const count = data.length

        for (let i = 0; i < count; i++) {
          let keys = Object.keys(data[i])
          keys.forEach((key) => {
            if (!viewColumnNames.includes(key)) {
              return
            }
            if (key === 'stage') {
              data[i][key] = stages.find((stage) => stage.code === data[i][key])?.name || data[i][key]
              return
            }
            data[i][key] = format2Print(key, data[i][key])
          })
        }

        return data
      } catch (e) {
        console.log('handlePrintClick', e)
      }
    }, [columns, stages, path])

    useImperativeHandle(ref, () => ({
      onPrintClick: handlePrintClick
    }))

    return (
      <ExportExcelButton
        fileName={'Замеры'}
        path={path}
        columns={columns}
        onPrintClick={handlePrintClick}
      />
    )
  })
)